module.exports = {"id":"208295","name":"Romain Saïss","rating":"76","photo":"./data/images/photos/0/208295.png","club":{"name":"Wolverhampton","logo":"./data/images/clubs/Wolverhampton.png"},"positions":["MDC","MC","DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RomainSaiss0.json
// module id = 3691
// module chunks = 0